/**
 * Перевіряє, чи знижка активна і не прострочена
 * @param {Object} discount - об'єкт знижки з полями active та dateEnd
 * @returns {boolean} - true, якщо знижка активна і не прострочена
 */
export const isDiscountValid = (discount) => {
  if (!discount) return false;
  
  const isActive = discount.active;
  if (!isActive) return false;

  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  
  const discountEndDate = new Date(discount.dateEnd);
  discountEndDate.setHours(0, 0, 0, 0);
  
  return discountEndDate >= currentDate;
};

/**
 * Отримує відсоток знижки, якщо вона дійсна
 * @param {Object} product - об'єкт товару
 * @returns {number} - відсоток знижки або 0
 */
export const getValidDiscountPercentage = (product) => {
  // Спочатку перевіряємо знижку категорії
  if (product.categories?.discount?.quantity > 0) {
    const categoryDiscount = product.categories.discount;
    if (isDiscountValid(categoryDiscount)) {
      // Якщо є знижка на товарі (не 0), то вона має пріоритет
      if (product.discount && product.discount > 0) {
        return product.discount;
      }
      // Інакше повертаємо знижку категорії
      return categoryDiscount.quantity;
    }
  }
  
  // Якщо немає дійсної знижки категорії, перевіряємо знижку товару
  if (product.discount && product.discount > 0) {
    return product.discount;
  }
  
  return 0;
};
